// Consent state lives in localStorage. Small string, never PII.
//
// `regime` is the geo-detected UI variant ("gdpr" | "lgpd" | "ccpa" |
// "us-state" | "us-default" | "default"). `decision` is the user's answer
// for that regime.
//
// Phase 3 collects only a coarse accept/decline plus regime so we can
// switch identity/engagement on in Phase 4. Granular toggles (ads,
// analytics, sensitive-data) are recorded as additional fields then.

export type ConsentRegime =
  | "gdpr"
  | "lgpd"
  | "ccpa"
  | "us-state"
  | "us-default"
  | "default";

export type ConsentDecision = "accepted" | "declined";

export interface ConsentRecord {
  regime: ConsentRegime;
  decision: ConsentDecision;
  decided_at: number;
}

const KEY = "agg:consent:v1";

export function loadConsent(): ConsentRecord | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ConsentRecord;
    if (!parsed.regime || !parsed.decision) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent(record: ConsentRecord): void {
  localStorage.setItem(KEY, JSON.stringify(record));
}

export function clearConsent(): void {
  localStorage.removeItem(KEY);
}
